import appConfig from "@/config/appConfig";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { BsEye, BsEyeSlash } from "react-icons/bs";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";

import { changeTheme } from "@/redux/slices/theme.slice";
import { setActiveDashboard, setIsLogged, setUserDetails } from "@/redux/slices/user.slice";

export const ResetPassword = () => {
  const Params = useParams();
  const token = Params.token;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showPasswordBlock, setShowPasswordBlock] = useState(false);
  const [resetPasswordData, setResetPasswordData] = useState({
    token: token,
    password: "",
    repeatPassword: "",
  });
  const isLogged = useSelector((state) => state.user?.isLogged);
  const { userDetails } = useSelector((state) => state.user || {});
  const business = userDetails?.business?.[0] || {};
  const resetPasswordToken = {
    token: token,
  };
  const { password, repeatPassword } = resetPasswordData;
  const onInputChange = (e) => {
    setResetPasswordData({
      ...resetPasswordData,
      [e.target.name]: e.target.value,
    });
  };
  const [newPasswordShown, setNewPasswordShown] = useState(false);
  const [repeatPasswordShown, setRepeatPasswordShown] = useState(false);
  const toggleNewPasswordShown = () => {
    setNewPasswordShown(!newPasswordShown);
  };
  const toggleRepeatPasswordShown = () => {
    setRepeatPasswordShown(!repeatPasswordShown);
  };

  const SubmitHandler = async (e) => {
    e.preventDefault();
    if (password === repeatPassword) {
      try {
        await axios.put(`/user/reset-password`, resetPasswordData, {
          withCredentials: true,
        });
        await Swal.fire({
          title: "Done!",
          text: "Password Reset Successfully",
          icon: "success",
          timer: 2000,
          confirmButtonText: "OK",
        });
        if (business?.businessUrl) {
          navigate("/" + business?.businessUrl);
        } else {
          navigate("/");
        }
      } catch {
        await Swal.fire({
          title: "",
          text: "Invalid Password Reset Link",
          icon: "error",
          timer: 2000,
          confirmButtonText: "OK",
        });
      }
    } else {
      await Swal.fire({
        title: "",
        text: "Both Password Are Not Matching",
        icon: "error",
        timer: 2000,
        confirmButtonText: "OK",
      });
    }
  };
  const checkTokenValid = async () => {
    try {
      await axios.post(`/user/reset-password-token`, resetPasswordToken, {
        withCredentials: true,
      });
      setShowPasswordBlock(true);
    } catch {
      await Swal.fire({
        title: "",
        text: "Invalid Password Reset Link ",
        icon: "success",
        timer: 2000,
        confirmButtonText: "OK",
      });
      setShowPasswordBlock(false);
    }
  };

  useEffect(() => {
    checkTokenValid();
  }, [token]);

  useEffect(() => {
    document.title = appConfig.name + " – Reset Password";
    if (isLogged) {
      axios
        .get(`/user/logout`, {
          withCredentials: true,
        })
        .then(() => {
          localStorage.setItem("isLoggedIn", "no");
          dispatch(setActiveDashboard(""));
          dispatch(setIsLogged(false));
          dispatch(changeTheme(false));
          dispatch(setUserDetails({}));
          // window.localStorage.clear();
        });
    }
  }, [isLogged]);

  let background = "/img/bg.jpg";
  return (
    <div>
      <div className="az-content-wrapper p-0" style={{ backgroundImage: `url(${background})` }}>
        <div>
          <div className="az-signin-wrapper">
            <div className="az-card-signin">
              <h1 className="az-logo" style={{ maxWidth: "260px", margin: "0 auto" }}>
                <img src="/img/logo.png" alt="logo" className="img-fluid" />
              </h1>
              <div className="az-signin-header">
                <h4>Reset Password?</h4>

                <form onSubmit={SubmitHandler} className={`${showPasswordBlock ? "" : "d-none"}`}>
                  <div className="form-group">
                    <label htmlFor="password" className="">
                      New Password
                    </label>
                    <div className="input-group">
                      <input
                        type={newPasswordShown ? "text" : "password"}
                        name="password"
                        value={password}
                        onChange={onInputChange}
                        minLength="6"
                        className="form-control"
                        id="password"
                        placeholder="Enter new password"
                        required
                      />
                      <span className="input-group-text" id="basic-addon1">
                        {newPasswordShown ? (
                          <BsEyeSlash onClick={() => toggleNewPasswordShown()} />
                        ) : (
                          <BsEye onClick={() => toggleNewPasswordShown()} />
                        )}
                      </span>
                    </div>
                  </div>
                  <div className="form-group">
                    <label htmlFor="repeatPassword">Repeat Password</label>
                    <div className="input-group">
                      <input
                        type={repeatPasswordShown ? "text" : "password"}
                        name="repeatPassword"
                        value={repeatPassword}
                        minLength="6"
                        onChange={onInputChange}
                        className="form-control"
                        placeholder="Retype Password"
                        required
                      />
                      <span className="input-group-text" id="basic-addon1">
                        {repeatPasswordShown ? (
                          <BsEyeSlash onClick={() => toggleRepeatPasswordShown()} />
                        ) : (
                          <BsEye onClick={() => toggleRepeatPasswordShown()} />
                        )}
                      </span>
                    </div>
                  </div>
                  <div className="mb-3 float-end">
                    <button
                      className="btn btn-primary px-5 me-2"
                      type="submit"
                      disabled={!password || !repeatPassword || password !== repeatPassword}
                    >
                      Submit
                    </button>
                    <Link to="/" className="btn btn-secondary">
                      Cancel
                    </Link>
                  </div>
                </form>
              </div>
              <div className="az-signin-footer text-center mt-2">
                <p>Version {appConfig.version}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
